export default function Process() {
  const steps = [
    {
      number: '01',
      icon: 'ri-search-eye-line',
      title: 'AI Discovery',
      description: 'We audit your current operations using AI diagnostics to identify inefficiencies, automation opportunities, and the highest-impact areas to transform first.'
    },
    {
      number: '02',
      icon: 'ri-settings-4-line',
      title: 'Intelligent Design',
      description: 'Our AI architects design a custom solution — blending smart automation, trained models, and elite human talent — built specifically around your workflows.'
    },
    {
      number: '03',
      icon: 'ri-plug-line',
      title: 'Seamless Integration',
      description: 'We deploy and connect your AI-powered team directly into your existing systems, tools, and processes with zero disruption from day one.'
    },
    {
      number: '04',
      icon: 'ri-bar-chart-grouped-line',
      title: 'Continuous Optimisation',
      description: 'Our AI monitors performance in real time, surfaces insights, and continuously improves outcomes — so your operations get smarter every single day.'
    }
  ];

  const insights = [
    {
      icon: 'ri-robot-line',
      color: 'bg-blue-100',
      iconColor: 'text-blue-600',
      label: 'AI-First',
      sub: 'Every solution built around AI'
    },
    {
      icon: 'ri-time-line',
      color: 'bg-green-100',
      iconColor: 'text-green-600',
      label: '48 Hours',
      sub: 'Average deployment time'
    },
    {
      icon: 'ri-shield-check-line',
      color: 'bg-indigo-100',
      iconColor: 'text-indigo-600',
      label: 'ISO Certified',
      sub: 'Enterprise-grade quality'
    },
    {
      icon: 'ri-arrow-up-line',
      color: 'bg-orange-100',
      iconColor: 'text-orange-600',
      label: '60% Savings',
      sub: 'Average cost reduction'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-full px-4 py-2 mb-4">
            <i className="ri-cpu-line text-blue-600 text-sm"></i>
            <span className="text-sm font-medium text-blue-700">How It Works</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            From Audit to AI-Powered Operations
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our proven four-step process gets your intelligent outsourcing solution live in as little as 48 hours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-14 left-full w-full h-0.5 bg-gradient-to-r from-blue-200 to-transparent -translate-x-4 z-0"></div>
              )}
              <div className="relative bg-white rounded-xl p-8 shadow-sm hover:shadow-lg transition-shadow border border-gray-100 hover:border-blue-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-lg">
                    <i className={`${step.icon} text-lg text-white`}></i>
                  </div>
                  <span className="text-4xl font-bold text-blue-100">{step.number}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed text-sm">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {insights.map((item, i) => (
              <div key={i} className="flex items-center gap-4">
                <div className={`w-12 h-12 flex items-center justify-center ${item.color} rounded-full shrink-0`}>
                  <i className={`${item.icon} text-xl ${item.iconColor}`}></i>
                </div>
                <div>
                  <div className="text-xl font-bold text-gray-900">{item.label}</div>
                  <div className="text-sm text-gray-500">{item.sub}</div>
                </div>
                {i < insights.length - 1 && <div className="hidden lg:block w-px h-10 bg-gray-200 ml-auto"></div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
